import React from 'react';  
import { connect } from "react-redux";

import Page from '../components/Page'
import axios from "axios";
import appConfig from '../config/config';

import { Card, CardBody, Button, CardTitle, CardText, CardSubtitle,Row,
    Col} from 'reactstrap';
import DashboardTile from '../components/common/DashboardTile';
import TileButton from '../components/common/TileButton';


class DashboardPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { data : [] }
    }

    loadData=()=>{
      axios.post(
        appConfig.apiGateway.updateOrderUrl, //Endpoint
        JSON.stringify({
            Action : "Dashboard",
            UserName: this.props.session.session.user.email
        })
      ).then((response) => {
        if (response.data.body.status) {
          this.setState({...this.state, data : response.data.body.Data})
        }
        else {

        }
      },
      (error)=>{

      })

    }
    componentDidMount() {
      this.loadData();
    }
    render() { 
        return (
          <Page className="DashboardPage" title="Dashboard">
            <div class="header-body">
              <div class="row">

                {this.state.data.map((item) => (
                  <div class="col-lg-6 col-xl-3">
                  <DashboardTile Header={item.header} 
                    HeaderData={item.data} Subtext="2%" 
                      Footer={item.title}
                      TitleId={item.tileid}/>
                  </div>  
                ))}

                {/* <div class="col-lg-6 col-xl-3">
                <DashboardTile Header="Orders" HeaderData="350" Subtext="2%" Footer="Since last month"/>
                </div>
                <div class="col-lg-6 col-xl-3">
                <DashboardTile Header="Orders" HeaderData="350" Subtext="2%" Footer="Since last month"/>
                </div>
                <div class="col-lg-6 col-xl-3">
                <DashboardTile Header="Orders" HeaderData="350" Subtext="2%" Footer="Since last month"/>
                </div>
                <div class="col-lg-6 col-xl-3">                 
                <DashboardTile Header="Orders" HeaderData="350" Subtext="2%" Footer="Since last month"/>
                </div> */}
                </div>

                <div class="row">
                <div class="col-lg-6 col-xl-3">
                <TileButton Menu="New Order" TileType="New"/>
                </div>
                <div class="col-lg-6 col-xl-3">
                <TileButton Menu="Search" TileType="Search"/>
                </div>
                </div>

              </div>
          </Page>
        );
    }
}
var dashBoardPage = connect(state => ({
  session: state.session
})
)(DashboardPage);
export default dashBoardPage;